/**
 * How long the page may spend deciding whether the Teamlio extension is here.
 *
 * Shared by the PF and TDS bridges so the two cannot drift apart: they are
 * the same check, against the same extension, behind buttons that behave the
 * same way.
 */

/** Chrome and Firefox both treat a click as user activation for about five
 *  seconds. A window.open after that is an unprompted popup, and blocked. */
export const USER_ACTIVATION_BUDGET_MS = 5000;

/** Retried once: an MV3 service worker that has gone idle can miss the first
 *  message while it is waking up. */
export const PING_ATTEMPTS = 2;

// 5000 was the bug. Nothing answers when no extension is installed, so
// two attempts burned the full ten seconds and the store tab that opened
// afterwards was blocked as a popup -- the button looked dead. A present
// extension answers in well under a second, waking service worker included,
// so the long wait only ever delayed the one case it could not help.
export const PING_TIMEOUT_MS = 1200;
